// src/components/ai-prayer/companion/BibleStudyInterface.tsx
import * as React from 'react';
const { useMemo } = React;
import { useLocation, useSearchParams } from 'react-router-dom';
import { UnifiedChatInterface } from './UnifiedChatInterface';

export function BibleStudyInterface() {
  const location = useLocation() as { state?: { prefill?: string } };
  const [params] = useSearchParams();

  const prefill = useMemo(
    () => (location?.state?.prefill || params.get('prefill') || '').trim(),
    [location, params]
  );

  return (
    <UnifiedChatInterface mode="study" initialUserMessage={prefill ? `Study ${prefill}` : ''} />
  );
}

